import type { ReactElement } from "react";

import { LocationDropdown } from "app/pages/sales-intelligence/common-components/dropdown/LocationDropdown";
import type { IEmployeeLocationFilterDto } from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import InclusionGroup from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/atoms/InclusionGroup";
import { FilterContentContainer } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/styles";

import { useEmployeeLocationFilter } from "../../hooks/useEmployeeLocationFilter";
import type { EmployeeLocationFilterOptions } from "../../types/dto";

type EmployeeLocationSelectorProps = {
    value?: IEmployeeLocationFilterDto;
    onChange: (value: IEmployeeLocationFilterDto) => void;
    options: EmployeeLocationFilterOptions;
    dataAutomation?: string;
};

export const EmployeeLocationSelector = ({
    value,
    onChange,
    options,
    dataAutomation = "employee-location",
}: EmployeeLocationSelectorProps): ReactElement => {
    const { inclusionValue, regions, countries, handleInclusionSelection, handleLocationChange } =
        useEmployeeLocationFilter({ options, value, onFilterUpdate: onChange });

    return (
        <FilterContentContainer data-automation={`${dataAutomation}-selector`}>
            <InclusionGroup
                value={inclusionValue}
                onChange={handleInclusionSelection}
            />

            <LocationDropdown
                regions={regions}
                countries={countries}
                value={value}
                onChange={handleLocationChange}
                dataAutomation={`${dataAutomation}-dropdown`}
            />
        </FilterContentContainer>
    );
};
